import { render } from "./SearchResultView.vue?vue&type=template&id=009c5151"
import script from "./SearchResultView.vue?vue&type=script&lang=js"
export * from "./SearchResultView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__